import React from "react";
import LearnMore from "../../../../../components/learnMore/learnMore";
import { MODULE_LOGICS } from "../constants";

const MembershipLengthLearnMore = ({ logic }) => {
  return logic === MODULE_LOGICS.AGREEMENTS ? (
    <LearnMore title="Membership Length by Agreement" content={getContent()} html />
  ) : null;
};

const getContent = () => {
  return `
  If you want to see how long members stay on a certain agreement, this module is for you.
   The entry point for this module is the membership agreement start date. 
  <br />
  <br />
  <b>Agreement Type:</b> </br>
  Only counting membership agreements. Any agreement that is not a membership will not be
   shown in this module. This filter allows you to select one of there different types of agreements.</br> 
    <b>All Agreements</b> will count every agreement that was written and activated. 
  </br>
    <b>Active Memberships</b> will count only active agreements. The agreement must not be cancelled to be considered active. </br>
    <b>Former Memberships</b> will count all cancelled agreements.  
  </br>
  </br>
    <b>Category:</b> This filter will display your membership agreements. You can select all, a single agreement or multiple.  
  </br>
  </br>
    <b>Date:</b> There is no calendar control. The data is based on the most recent update to your data. 
  </br>
  </br>
    <b>All Time/Active/Former Memberships</b> will count all agreements based on the Agreement Type filter. Since we are counting all
     agreements, this number will not be unique. A member can show up multiple times in this count. 
  </br>
  </br>
    <b>Unique Members</b> Looking at the Agreement Type memberships but only counting each member once.
  </br>
  </br>
    <b>Average Length</b> Based on your filters we will display the average amount of time (in months) that the agreement was active. 
  </br>
  </br>
    <b>Table:</b>
  </br>
    iKizmet will show each agreement on a single line with some key metrics.  
  </br>
    <b>All Time Average</b> we will display the average amount of time (in months) that the agreement was active.
  </br>
    <b>Former Average</b> we will display the average amount of time (in months) that the agreement was active but only for memberships that have been cancelled. 
  </br>
    <b>All Time Memberships</b> we will count the number of memberships for that particular agreement that was ever active.
  </br>
    <b>Active Memberships</b> we will count the number of memberships for that particular agreement but only those that are currently active.
  </br>
    <b>Former Memberships</b> we will count the number of memberships for that particular agreement but only those have cancelled.
  </br>
`;
};

export default MembershipLengthLearnMore;
